// @flow
import axios from 'lib/defaultClient';

export const getTags = (sort: string = 'popular') => {
  return axios.get(`/common/tags?sort=${sort}`);
};

export const getTagInfo = (tag: string) => {
  return axios.get(`/common/tags/${tag}`);
};

export const getSections = () => {
  return axios.get(`/common/sections`);
};

export const getCategorySections = () => {
  return axios.get(`/common/sections/category`);
};

export const getSectionInfo = (section: string, offset: number = 0, limit: number = 48) => {
  return axios.get(`/common/sections/${section}`, { params: { offset, limit } });
};

export const getProductsTags = (sort: string = 'popular') => {
  return axios.get(`/common/products/tags?sort=${sort}`);
};

export const getProductsTagInfo = (tag: string) => {
  return axios.get(`/common/products/tags/${tag}`);
};

export const getCategories = (sort: string = 'popular') => {
  return axios.get(`/common/categories?sort=${sort}`);
};

export const getCategoryInfo = (category: string) => {
  return axios.get(`/common/categories/${category}`);
};

export type CreateGeneralUploadUrlPayload = { refId?: string, filename: string, type: string };

export const createGeneralUploadUrl = ({
  refId,
  type,
  filename,
}: CreateGeneralUploadUrlPayload) => {
  return axios.post('/files/create-url/general', { ref_id: refId, filename, type });
};

export const createPublicUploadUrl = ({ refId, type, filename }: CreateGeneralUploadUrlPayload) => {
  return axios.post('/files/create-url/public', { ref_id: refId, filename, type });
};

export const getSectionsWithBadges = () => {
  return axios.get('/common/sections/badges/all');
};

export const getAllBadges = () => {
  return axios.get('/common/badges/all');
};

export const getBadgeProducts = (badgeId: string, limit: number = 12, cursor?: string) => {
  const params = { limit };
  if (cursor) {
    params.cursor = cursor;
  }
  return axios.get(`/common/badges/${badgeId}/products`, { params });
};



// WEBPACK FOOTER //
// ./src/lib/api/common.js